import { useFeedback } from '../../feedback/index.js';
import { useEffect, useRef, useState } from 'react';
import { sanitizeContentClipboardNode } from './contentEditorCommands.js';

function PatternThumbnail({ document }) {
  const draw = (node, index, depth = 0) => {
    if (!node || depth > 3) return null;
    const children = Array.isArray(node.content) ? node.content.slice(0, 6) : [];
    const layout = ['container', 'columns', 'column'].includes(node.type);
    return <span key={index} className={`mts-editor-pattern-shape ${layout ? 'mts-editor-pattern-layout' : ['image', 'emailImage', 'hero'].includes(node.type) ? 'mts-editor-pattern-media' : ['contentButton', 'emailButton'].includes(node.type) ? 'mts-editor-pattern-button' : 'mts-editor-pattern-line'}`} data-pattern-layout={node.attrs?.layout === 'row' || children.some(child => child.type === 'column') ? 'row' : 'stack'}>{layout ? children.map((child, position) => draw(child, position, depth + 1)) : null}</span>;
  };
  const nodes = Array.isArray(document?.content) ? document.content.slice(0, 6) : [];
  return <span className="mts-editor-pattern-thumbnail" aria-hidden="true">{nodes.length ? nodes.map((node, index) => draw(node, index)) : <span>Preview unavailable</span>}</span>;
}

export function ContentEditorPatterns({ patterns, adapter, selection, disabled, onInsert }) {
  const toast = useFeedback();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  const contextRef = useRef(null);
  if (!contextRef.current || contextRef.current.adapter !== adapter || contextRef.current.disabled !== disabled) contextRef.current = { adapter, disabled };
  useEffect(() => { setBusy(false);  }, [adapter, disabled]);
  useEffect(() => { setName(''); }, [adapter]);
  useEffect(() => {
    contextRef.current ||= { adapter, disabled };
    return () => { contextRef.current = null; };
  }, []);
  const save = async (event) => {
    event.preventDefault();
    if (!selection || !name.trim() || disabled || !adapter?.create) return;
    const context = contextRef.current;
    setBusy(true);
    try {
      await adapter.create({ name: name.trim(), documentJson: { type: 'doc', content: [sanitizeContentClipboardNode(selection.node.toJSON())] } });
      if (contextRef.current !== context) return;
      setName(''); toast.success('Pattern saved.', { id: 'action:ContentEditorPatterns:save' });
    } catch (error) { if (contextRef.current === context) toast.error(error.message || 'Pattern could not be saved.', { id: 'action:ContentEditorPatterns:save' }); }
    finally { if (contextRef.current === context) setBusy(false); }
  };
  return <section aria-label="Content patterns" className="mts-editor-panel"><h2>Patterns</h2>
    {patterns.map((pattern) => <button key={pattern.id} type="button" className="mts-editor-pattern-card" aria-label={pattern.name} disabled={disabled} onClick={() => onInsert(pattern)}><PatternThumbnail document={pattern.documentJson}/><strong>{pattern.name}</strong>{pattern.description ? <span>{pattern.description}</span> : null}</button>)}
    {!patterns.length ? <p>No patterns available.</p> : null}
    {adapter?.create ? <form onSubmit={save}><label>Pattern name<input disabled={disabled || busy} value={name} onChange={(event) => setName(event.target.value)}/></label><button disabled={disabled || busy || !selection || !name.trim()}>Save selected block as pattern</button></form> : null}

  </section>;
}
